module.exports = __webpack_public_path__ + "img/11_Kombipaket-2.c26643b4.jpg";